<template>
  <div class="container" style="width: 1280px;">
    <div class="one">
      <div class="schoolWZ">
        <div class="SCLeft">
          <span>专业类型</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator="">
            <el-breadcrumb-item v-for="(item,index) in typeFirst" :key="index"><a @click="isT(index,item.majorSubject)"
                :class=" item.majorSubject == majorSubject ? 'active' :''">{{item.name}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <!-- <div class="em"></div> -->
      <div class="schoolWZ">
        <div class="SCLeft">
          <span>专业类别</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator="">
            <el-breadcrumb-item v-for="(item,index) in typeSecond"  :key="item.obj.marjoeTypeId" v-if="item.obj.majorSubject == majorSubject"><a
                @click="isT1(index)" :class=" item.obj.marjoeTypeId ==marjoeTypeId  ? 'active' :''">{{item.obj.majorTypeName}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <!-- <div class="em1"></div> -->
      <div class="schoolWZ">
        <div class="SCLeft">
          <span>专业大类</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator="">
            <el-breadcrumb-item v-for="(item,index) in typeThird"  :key="item.marjoeTypeId"><a @click="isT2(index)"
                :class=" typeId ==item.marjoeTypeId  ? 'active' :''">{{item.majorTypeName}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    components: {

    },
    props: {
      subject: {
        type:Number,
        default:1
      }
    },
    data() {
      return {
        isTrue: 0,
        isTrue1: 0,
        isTrue2: 0,
        isTrue3: 0,
        majorSubject: 1,
        marjoeTypeId: '',
        // 面包屑渲染
        typeFirst: [{
            name: '本科',
            majorSubject: 1
          },
          {
            name: '专科',
            majorSubject: 0
          },
        ],
        typeSecond: [],
        typeThird: [],
        typeId: "",
        typeIdinfo: {}
      }
    },
    methods: {
      isT(index, majorSubject) {
        console.log(111)
        this.majorSubject = majorSubject
        this.marjoeTypeId = this.typeSecond[this.typeIdinfo[majorSubject]].obj.marjoeTypeId
        this.typeThird = this.typeSecond[this.typeIdinfo[majorSubject]].children
        this.typeId =this.typeSecond[this.typeIdinfo[majorSubject]].children[0].marjoeTypeId
        this.getMajor();
      },
      isT1(index) {
        this.marjoeTypeId = this.typeSecond[index].obj.marjoeTypeId
        this.typeThird = this.typeSecond[index].children
        this.typeId =this.typeSecond[index].children[0].marjoeTypeId
        this.getMajor();
      },
      isT2(index) {
        this.typeId = this.typeThird[index].marjoeTypeId
        this.getMajor();
      },
      getData() {
        let _this = this;
        this.$req.majorType_selectAll({}).then(function(response) {
          response.data.forEach(function(item, index) {
            if (_this.typeIdinfo[item.obj.majorSubject] == null) {
              _this.typeIdinfo[item.obj.majorSubject]=index
            }
            item.children.forEach(function(son, i) {
              if (index == 0 && i == 0) {
                _this.typeId = son.marjoeTypeId
              }
            })
            if (index == 0) {
              _this.marjoeTypeId = item.obj.marjoeTypeId
              _this.typeThird = item.children
            }
          })
          _this.typeSecond = response.data
          console.log(_this.typeIdinfo)
          console.log(_this.subject)
          _this.isT(0, _this.subject)
          _this.getMajor();
        })
      },
      getMajor(){
        this.$emit("select",this.typeId)
      }
    },
    created() {

      this.getData()
    }


  }
</script>

<style scoped>
  .one {
    margin-top: 20px;
    justify-content: flex-start;
    width: 100%;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 200px;


  }

  .el-breadcrumb {}

  .one span {
    line-height: 40px;
    margin-right: 8px;
  }

  .schoolWZ {
    width: 100%;
    height: auto;
    display: flex;
  }


  .schoolWZ .SCLeft {
    width: 115px;
  }

  .schoolWZ .SCmain {
    width: 64px;
    height: 60px;
    margin-right: 15px;
    margin-top: 10px;

  }

  .schoolWZ .SCmain a {
    display: block;
    text-align: center;
    line-height: 32px;
    font-weight: 600;
    height: 32px;
    color: #333333;
    opacity: 1;
    cursor: pointer;
    font-size: 14px;

    margin: 0 10px;
  }

  .active {
    background: #e63233;
    color: #fff !important;
    border-radius: 16px;

    box-sizing: border-box;
  }

  .schoolWZ .SCbottom {
    width: 100%;
    text-align: left;
    padding-bottom: 10px;
    border-bottom: 1px #eee9e9 solid;
  }

  .schoolWZ:nth-of-type(3) .SCbottom {
    padding-bottom: 10px;
    border-bottom: none;
  }

  .schoolWZ .SCbottom a {
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 20px;
    padding: 4px 6px;
    color: #333333;
    opacity: 1;
  }




</style>



// WEBPACK FOOTER //
// src/components/saixuantop1.vue